const TestimonialBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g>
      <g>
        <g>
          <rect width="24" height="24" fill="#333" />
          <rect x="2" y="2" width="20" height="20" fill="#ffd400" />
          <path
            d="M11.16,8.48c-.46.26-.83.49-1.11.68a5.21,5.21,0,0,0-.87.75,3.59,3.59,0,0,0-.63.92,4.48,4.48,0,0,0-.31,1.24H9a2.13,2.13,0,0,1,1.43.45,1.65,1.65,0,0,1,.52,1.31A1.74,1.74,0,0,1,10.43,15a1.56,1.56,0,0,1-1.26.53,2,2,0,0,1-1.8-.82,3.84,3.84,0,0,1-.55-2.17,3.75,3.75,0,0,1,.41-1.74,6.39,6.39,0,0,1,1-1.39A7.36,7.36,0,0,1,9.5,8.32l1.13-.72Zm5.42,0c-.46.26-.83.49-1.11.68a5.21,5.21,0,0,0-.87.75,3.6,3.6,0,0,0-.64.93,4.42,4.42,0,0,0-.3,1.23h.71a2.13,2.13,0,0,1,1.43.45,1.65,1.65,0,0,1,.52,1.31A1.74,1.74,0,0,1,15.85,15a1.56,1.56,0,0,1-1.26.53,2,2,0,0,1-1.8-.82,3.84,3.84,0,0,1-.55-2.17,3.75,3.75,0,0,1,.41-1.74,6.39,6.39,0,0,1,1-1.39,7.36,7.36,0,0,1,1.27-1.07l1.13-.72Z"
            fill="#333"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default TestimonialBlockIcon;
